// These constants are used as a common reference for all elements, including:
// blocks, form editor elements, and public site form elements

// NOTE: Each element constant should be unique!

const ElementConstants = {
	INPUTS: {
		CONTACT : 'CONTACT',
		ADDRESS: 'ADDRESS',
		TEXT: 'TEXT_INPUT',
		TEXTAREA: 'TEXTAREA_INPUT',
		NUMBER: 'NUMBER_INPUT',
		LINK: 'LINK_INPUT',
		DATE: 'DATE_INPUT',
		TIME: 'TIME_INPUT',
		FILE_UPLOAD: 'FILE_UPLOAD_INPUT',
		EMAIL: 'EMAIL_INPUT',
		RADIO_BUTTON: 'RADIO_BUTTON_INPUT',
		CHECKBOX: 'CHECKBOX_INPUT',
		MULTI_CHOICE_PAY_OPTION: 'MULTI_CHOICE_PAY_OPTION',
		OTHER_MULTI_CHOICE_PAY_OPTION: 'OTHER_MULTI_CHOICE_PAY_OPTION',
		PHONE: 'PHONE_INPUT',
		USER_SIGNATURE: 'USER_SIGNATURE'
	},
	INPUT_GROUPS: {
		CHECKBOXES: 'CHECKBOX_GROUP',
		RADIO_BUTTONS: 'RADIO_BUTTON_GROUP',
		SELECT_MENU: 'SELECT_MENU_GROUP',
		TABLE: 'TABLE_GROUP',
		RATING: 'RATING_GROUP'
	},
	EXTRAS: {
		HORIZONTAL_DIVIDER: 'HORIZONTAL_DIVIDER_EXTRA',
		TEXT_BOX: 'TEXT_BOX_EXTRA'
	},
  PAYMENTS: {
    OPEN: 'OPEN_PAYMENT_INPUT',
    MULTI_CHOICE: 'MULTI_CHOICE_PAY_GROUP',
    ITEM: 'PAYMENT_ITEM'
  }
};

export default ElementConstants;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/elements.js